import { useEffect, useState } from 'react';

export const useIsComponentOverflowing = (
    ref: React.RefObject<HTMLElement>,
    text: string
) => {
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            const container = ref.current;
            if (!container) return;

            // Create a temporary span inside the container
            const span = document.createElement('span');
            // Adding a zero-width space to avoid altering layout
            span.textContent = '\u200B'; // Zero-width space
            container.appendChild(span);

            // Check if the span is outside the visible boundary of the container
            const isOverflow =
                span.offsetTop + span.clientHeight > container.clientHeight;

            // Clean up by removing the span
            container.removeChild(span);

            setIsOverflowing(isOverflow);
        };

        checkOverflow();
        // Optional: Re-run when the window resizes or text changes
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [text, ref]); // Dependency array includes 'text' to re-run effect if text changes

    return isOverflowing;
};
